<template>
  <div class="component-wrap" :class="{'component-padded' : base.padded, 'active': active}">
    <div class="current-active"></div>
    <div v-if="base.title" class="component-header">
      <div class="component-title" :class="{'middle' : config.type !== 'goods_category_list'}">
        <div>{{base.title}}</div>
        <div  class="subtitle">{{base.subtitle}}</div>
      </div>
      <div class="component-more">
        <div class="three-dot"></div>
      </div>
    </div>
    <div class="component-body seckill" >
      <div class="scroll-goods">
        <div v-for="(item, index) in data" :key="index" class="scroll-item">
          <div v-if="config.leaderboard" class="subscript">
            <div class="subscript-text">NO.{{index+1}}</div>
            <img class='subscript-img' :src="subscriptImg"/>
          </div>
          <div class="thumbnail">
            <img class="goods-img" :src="item.imgUrl" />
          </div>
          <div v-if="config.showPrice" class="caption">
            <template >
              <span class="cur">¥</span>{{item.price ? item.price/100 : '0.00'}} <span class="marketing-price">{{item.market_price ? item.market_price/100 : '0.00'}}</span>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getSeckillItemList } from '@/api/promotions'
const subscript = require('@/../static/img/subscript.png')
import { getCategory ,getDistributorCategoryItemsList} from '@/api/goods'
export default {
  props: {
    res: {
      type: Object,
      default: {}
    },
    active: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    res: {
      deep: true,
      handler (value) {
        if (value) {
          this.setData(value)
        }
      },
    },
  },
  data () {
    return {
      base: {},
      config: '',
      data: [],
      goodslist:[],
      text: '',
      time: 0,
      subscriptImg: subscript,
    }
  },
  components: {
  },
  methods: {
    setData(val) {
      this.base = val.base
      this.config = val.config
      this.data = val.data
    },
    getItemsLists(){
      var distributor_id;
      if(this.$route.query && this.$route.query.distributor_id !=undefined){
          distributor_id=this.$route.query.distributor_id;
      }else{
          distributor_id=34;
      }
      var param={
        distributor_id:distributor_id,
        category_id:this.base.category_id,
        page:1,
        pageSize:10,
        is_can_sale:true,
      };
      console.log(1111111111111)
      console.log(this.base)
      console.log(2222222222222)
      console.log(this.config)
      console.log(3333333333333)
      console.log(this.data)
      if(param.category_id > 0) {
        getDistributorCategoryItemsList(param).then(response => {
          console.log(response.data.data.list);
          this.goodslist=[];
          if(response.data.data.list.length>0){
            this.goodslist = response.data.data.list
            this.goodslist.forEach((item, index) => {
            let obj = {
              imgUrl: item.pics[0],
              title: item.item_name,
              price: item.price,
              distributor_id: distributor_id,
              market_price: item.market_price,
              item_bn: item.item_bn,
              item_id: item.item_id,
              goodsId: item.goods_id,
            }
            this.data.splice(index, 1, obj)
          })
          }
        })
      }
    }
  },
  mounted() {
    this.setData(this.res)
  }
}
</script>

<style scoped lang="scss">
.goods {
  position: relative;
  height: 100px;
}
.seckill {
  position: relative;
  height: 130px;
}
.activity-timer {
  display: flex;
  align-items: center;
  padding-left: 10px;
  font-size: 11px;
  .time-box {
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 20px;
    height: 20px;
    padding: 0 3px;
    background: #333;
    color: #fff;
    border-radius: 2px;
    font-size: 10px;
    font-family: sans-serif;
  }
  .dot {
    padding: 0 2px;
  }
}
.scroll-goods {
  position: absolute;
  width: 100%;
  white-space: nowrap;
  overflow-x: auto;
  .scroll-item {
    display: inline-block;
    position: relative;
    padding: 3px 0 0 3px;
    margin-left: 5px;
    &:first-child {
      margin-left: 10px;
    }
    &:last-child {
      margin-right: 10px;
    }
    .subscript {
      position: absolute;
      left: 0;
      top: 0;
      width: 40px;
      height: 40px;
      z-index: 90;
      .subscript-img {
        width: 100%;
        height: 100%;
      }
      .subscript-text {
        position: absolute;
        top: 4px;
        transform: rotate(-45deg);
        color: #fff;
        font-size: 12px;
      }
    }
    .thumbnail {
      position: relative;
      width: 95px;
      border-radius: 6px;
      border: 1px solid #f5f5f5;
      &::after {
        display: flex;
        padding-top: 100%;
        content: "";
      }
      .goods-img {
        display: block;
        position: absolute;
        width: 100%;
        height: 100%;
      }
    }
    .caption {
      padding-top: 3px;
      height: 30px;
      font-size: 14px;
      color: #fc511f;
      font-weight: 600;
      .cur {
        font-size: 10px;
      }
      .marketing-price {
        padding-left: 5px;
        font-size: 11px;
        color: #ccc;
        text-decoration: line-through;
        font-weight: 500;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// goods_category_list.vue?5f8c242a